import React, { useEffect } from 'react'

import clsx from 'clsx'

import classes from './TouchRipple.module.scss'

/** @type {import("./types").default} */
const TouchRipple = ({ rippleRef }) => {
  useEffect(() => {
    if (rippleRef.current) {
      const createRipple = event => {
        const button = rippleRef.current
        const ripple = button.getElementsByClassName(classes.ripple)[0]
        if (ripple) {
          ripple.remove()
        }

        const { top, left } = button.getBoundingClientRect()
        const circle = document.createElement('span')
        const diameter = Math.max(button.clientWidth, button.clientHeight)
        const radius = diameter / 2
        const rippleColor = window.getComputedStyle(button).color

        circle.style.width = circle.style.height = `${diameter}px`
        circle.style.left = `${event.clientX - left - radius}px`
        circle.style.top = `${event.clientY - top - radius}px`
        circle.classList.add(classes.ripple)
        circle.style.backgroundColor = rippleColor
        circle.style.opacity = '0.1'

        button.appendChild(circle)
      }
      rippleRef.current.pulsate = createRipple
    }
  }, [rippleRef])

  return <span ref={rippleRef} className={clsx('TouchRipple', classes.wrapper)} role="figure" />
}

export default TouchRipple
